export default __webpack_public_path__ + "static/media/user-signed.0213e943.svg";